import {
  ErrorAccessDeniedImage,
  ErrorFallbackImage,
  ErrorNotFoundImage,
  ErrorServerImage,
} from '@vk-hr-tek/ui/graphics';
import {
  HTTP_BAD_REQUEST_STATUS,
  HTTP_FORBIDDEN_STATUS,
  HTTP_INTERNAL_SERVER_ERROR_STATUS,
  HTTP_NO_CONTENT_STATUS,
  HTTP_NOT_FOUND_STATUS,
  HTTP_NOT_UNAUTHORIZED_STATUS,
  HTTP_BAD_GATEWAY_STATUS,
  HTTP_SERVICE_UNAVAILABLE_STATUS,
} from '@vk-hr-tek/core/http/codes';

import { PageErrorConfig } from '../types';

export const DEFAULT_PAGE_ERROR_CONFIG: PageErrorConfig = {
  title: 'Произошла ошибка',
  caption: 'Не удалось выполнить указанное действие. Попробуйте еще раз',
  image: ErrorFallbackImage,
  showReload: true,
};

export const PAGE_ERROR_CONFIG: Partial<Record<number, PageErrorConfig>> = {
  [HTTP_NO_CONTENT_STATUS]: {
    title: 'Не удалось получить данные',
    caption:
      'Открытие создания заявки для указанной группы не завершилось успехом',
    image: ErrorFallbackImage,
    showHistory: true,
    showBack: true,
  },
  [HTTP_BAD_REQUEST_STATUS]: {
    title: 'Произошла ошибка',
    caption: 'Не удалось выполнить указанное действие. Попробуйте еще раз',
    image: ErrorFallbackImage,
    showSupport: true,
    showReload: true,
  },
  [HTTP_NOT_UNAUTHORIZED_STATUS]: {
    title: 'Неавторизованный запрос',
    caption: 'Похоже вы неавторизованы, просмотр недоступен',
    image: ErrorAccessDeniedImage,
  },
  [HTTP_FORBIDDEN_STATUS]: {
    title: 'Нет доступа',
    caption: 'У вас недостаточно прав для просмотра этой страницы',
    image: ErrorAccessDeniedImage,
    showHistory: true,
  },
  [HTTP_NOT_FOUND_STATUS]: {
    title: 'Страница не найдена',
    caption: 'Страница не существует или была удалена',
    image: ErrorNotFoundImage,
    showHistory: true,
    showBack: true,
  },
  [HTTP_INTERNAL_SERVER_ERROR_STATUS]: {
    title: 'Произошла ошибка',
    caption: 'Выполнение данной операции на текущий момент недоступно.',
    image: ErrorFallbackImage,
    showSupport: true,
    showReload: true,
  },
  [HTTP_BAD_GATEWAY_STATUS]: {
    title: 'Сервис временно недоступен',
    caption:
      'Работы по восстановлению уже ведутся и будут завершены в ближайшее время.',
    image: ErrorServerImage,
    showStatusPage: true,
    ignoreErrorMessage: true,
    showReload: true,
  },
  [HTTP_SERVICE_UNAVAILABLE_STATUS]: {
    title: 'Сервис временно недоступен',
    caption:
      'Работы по восстановлению уже ведутся и будут завершены в ближайшее время.',
    image: ErrorServerImage,
    showStatusPage: true,
    ignoreErrorMessage: true,
    showReload: true,
  },
};
